import type { TopicExercises } from "~/features/computer/data/exercises/exercise.types";

export const expressionsExercises: TopicExercises = {
  mcqs: [
    {
      id: "expr1",
      question: "3 + 4 * 2 ka result kya hoga?",
      options: ["14", "11", "16", "7"],
      correctIndex: 1,
      explanation: "Multiplication pehle hoti hai. 4 * 2 = 8, phir 3 + 8 = 11.",
    },
    {
      id: "expr2",
      question: "(3 + 4) * 2 ka result kya hoga?",
      options: ["11", "7", "14", "8"],
      correctIndex: 2,
      explanation: "Parentheses ke andar wali expression pehle solve hoti hai. 3 + 4 = 7, phir 7 * 2 = 14.",
    },
  ],
  short: [
    {
      id: "expr-short-1",
      question: "Expression kya hota hai?",
      answer: "Expression values aur operators ka combination hota hai jo aakhir mein aik result deta hai.",
    },
  ],
  long: [
    {
      id: "expr-long-1",
      question: "10 + 3 * 2 ** 5 / 5 ko evaluate karo.",
      solution: "Pehle 2 ** 5 = 32. Phir 3 * 32 = 96. Phir 96 / 5 = 19.2. Aakhir mein 10 + 19.2 = 29.2.",
    },
  ],
};
